import React from 'react'

export default function Banner() {
  return (
    <article className="card p-4 bg-primary">
    <div className="row align-items-center">
       <div className="col">
          <h4 className="mb-0 text-white"> 40% de descuento en tu primera compra</h4>
          <p className="mb-0 text-white-50">Aplica todos los productos</p>
       </div>
       <div className="col-auto"> <a className="btn btn-warning" href="#">Comprar</a> </div>
    </div>
 </article>
  )
}
